import { spLogTags } from '@eventr/common'
import {
    ClaimHide,
    ColoursObj,
    getContrastYIQ,
    MainButton,
} from '@eventr/common-storybook'
import { RocketCreateDirectChannelBodyType } from '../../data/Rocket'
import { useRocketChatContext } from '../../feat/rocketchat/rocketChatProvider'
import { bs, useBoundStore } from '../../state/bound.store'
import { loadingSignal } from '../../state/overlayState/overlaySignals'
import { liveToken } from '../../state/rocketchatState/rocketchatSignals'

export const DirectChatButton = ({
    user_id,
    user_id2,
    fullWidth,
}: RocketCreateDirectChannelBodyType) => {
    const {
        createDirectChannel,
        openChat,
        userRooms,
        rcUserList,
        isActivated,
        chatView,
    } = useRocketChatContext()

    const orgConfig = useBoundStore((s) => s.orgConfig)

    if (orgConfig.disableChat) {
        return null
    }

    const createChat = () => {
        loadingSignal.value = true
        createDirectChannel({
            user_id: user_id,
            user_id2: user_id2,
        })
            .then(async (c) => {
                if (c.status === 'success') {
                    await bs().pullRocketChatChannels()
                    openChat(c?.data?.channel_id, 'd')
                } else {
                    spLogTags(
                        'Error creating direct chat',
                        ['ERROR', 'rocketchat'],
                        c
                    )
                }
            })
            .catch((err) => {
                spLogTags(
                    'Exception while creating direct chat',
                    ['ERROR', 'rocketchat'],
                    err
                )
            })
            .finally(() => {
                loadingSignal.value = false
            })
    }

    const searchChat = () => {
        chatView.value = 'default'
        bs()
            .getDirectChannel(user_id, user_id2)
            .then((c) => {
                if (c) {
                    openChat(c?.channel_id, 'd')
                } else {
                    createChat()
                }
            })
            .catch((err) => {
                spLogTags(
                    'Error fetching direct channel',
                    ['ERROR', 'rocketchat'],
                    err
                )
            })
    }

    function roomStatus() {
        // return null

        if (userRooms && userRooms.length > 0 && rcUserList) {
            const user2 = rcUserList.find((user) => {
                if (user.customFields && user.customFields.wpUserID) {
                    return (
                        user.customFields.wpUserID.toString() ===
                        user_id2.toString()
                    )
                } else {
                    return false
                }
            })

            const rooms = userRooms.filter(
                (room) =>
                    room.uids &&
                    room.uids.length <= 2 &&
                    room.uids.length > 0 &&
                    user2 &&
                    room.uids.includes(user2._id as string)
            )

            if (rooms.length > 0) {
                if (user_id === user_id2) {
                    return 'read'
                }
                if (rooms.length === 1) {
                    if ((rooms[0]?.unread ?? 0) > 0) {
                        return 'unread'
                    } else {
                        return 'read'
                    }
                } else {
                    if (!rooms.every((room) => room.unread === 0)) {
                        return 'unread'
                    } else {
                        return 'read'
                    }
                }
            } else {
                return false
            }
        } else {
            return null
        }
    }

    const iconColour =
        roomStatus() === 'unread'
            ? 'unset'
            : roomStatus() === 'read'
            ? ColoursObj.font.primary
            : getContrastYIQ(
                  ColoursObj.backgrounds.primary,
                  ColoursObj.shades.shade2,
                  ColoursObj.shades.shade5
              )

    if (orgConfig.disableChat) {
        return null
    }

    return (
        <>
            {isActivated && (
                <ClaimHide paths={['/']} claims={['chatAccess']}>
                    <MainButton
                        id={'directChatButton' + user_id2 + user_id}
                        style={
                            !fullWidth
                                ? {
                                      width: '24px',
                                      height: '24px',
                                      padding: '0px',
                                      margin: '0px',
                                      justifyContent: 'end',
                                      alignSelf: 'center',
                                      border: 'none',
                                  }
                                : { width: '100%' }
                        }
                        onClick={() => {
                            liveToken.value !== undefined
                                ? searchChat()
                                : window.pushPath('/tabs/rocketChat')
                        }}
                        icon={roomStatus() === 'unread' ? 'Chat_Notf' : 'Chat'}
                        variant={fullWidth ? undefined : 'ghost'}
                        text={fullWidth ? 'Message' : undefined}
                        iconColour={iconColour}
                    />
                </ClaimHide>
            )}
        </>
    )
}
